module.exports = __webpack_public_path__ + "static/media/mobileapp.a9f06063.jpeg";